import { SignupForm } from "@components/_auth/signup/form"
import { SplitScreenPage } from "@components/_auth/SplitScreenPage"
import { NextPage } from "next"

const SignupFormPage: NextPage = () => {
  return (
    <SplitScreenPage
      description="Signup and unlock the full potential of Viesus Cloud"
      contentWrapperClassName="max-w-full max-h-[calc(100vh-48px)] overflow-y-auto justify-center"
    >
      <SignupForm />
    </SplitScreenPage>
  )
}

export default SignupFormPage
